import { io } from 'socket.io-client';

const getAuthToken = () => localStorage.getItem('accessToken');

// Base host of the socket.io gateways (port 1235 locally). Falls back to
// production when REACT_APP_SOCKET_URL is not set.
const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_URL || 'wss://api.cliclaim.com';

export const notificationsSocket = io(`${SOCKET_BASE_URL}/notifications`, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  auth: (cb) => {
    cb({ token: getAuthToken() });
  }
});
